import React from 'react';

import { renderErrorMessage } from '@lyearn/form/src/Form/components/InputFields/renderers';
import { useTranslation } from '@lyearn/i18n';
import { Box, Typography } from '@lyearn/ui';
import { ErrorPosition } from '@/components/Form';

import ClientSelectSearch from './ClientSelectSearch';
import { ClientSelectProps } from './types';

function ClientSelect(props: ClientSelectProps) {
  const { t } = useTranslation();

  return (
    <Box>
      {props.hideHeader ? null : (
        <Typography className="mb-8 ms-8" variant="body-short-02">
          {t('Common:Filter.Clients')}
        </Typography>
      )}
      <ClientSelectSearch {...props} />
      {props.error
        ? renderErrorMessage({ errorMessage: props.error, errorPosition: ErrorPosition.Bottom })
        : null}
    </Box>
  );
}

export default ClientSelect;
